import { render, staticRenderFns } from "./ModifierGroupListContainer.vue?vue&type=template&id=729e30c8"
import script from "./ModifierGroupListContainer.vue?vue&type=script&lang=js"
export * from "./ModifierGroupListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports